import {Component, ChangeDetectionStrategy, Input} from '@angular/core';
import {Operand} from '@em/shared/mapping-engine/domain-models';

@Component({
  selector: 'em-operand-with-icon',
  templateUrl: './operand-with-icon.component.html',
  styleUrls: ['./operand-with-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmOperandWithIconComponent {
  @Input() operand: Operand | undefined;
  @Input() isCustom = false;

  constructor() {}
}
